import React from "react";
import { ReactComponent as WhatsappIcon } from "../assets/svg/whatsapp.svg";
import Cookies from "js-cookie";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;

const whatsappNo = customerData?.SalesPersonMobileNo?.trim()
  ? customerData.SalesPersonMobileNo
  : "9867939900";

const WhatsappFloatBtn = () => {
  return (
    <div className="whatsapp_float_btn">
      <a
        href={`https://api.whatsapp.com/send?phone=91${whatsappNo}&text=Hi%27,%20like%20to%20chat%20with%20you`}
        target="_blank"
        rel="noreferrer"
      >
        <WhatsappIcon width="50" height="50" />
      </a>
    </div>
  );
};

export default WhatsappFloatBtn;
